var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Box',{staticClass:"c-view-zones"},[_c('EditZonesTable',{attrs:{"zones":_vm.building.current_state.zones.zones,"edit":false},model:{value:(_vm.model.zones),callback:function ($$v) {_vm.$set(_vm.model, "zones", $$v)},expression:"model.zones"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }